<div
  [ngClass]="{
    column: isVertical,
    'row align-items-center': !isVertical
  }"
  >
  <div
    [ngClass]="{
      'align-middle mb-1': isVertical,
      'align-middle col-md-3 col-12': !isVertical
    }"
    >
    <div class="d-flex align-items-center">
      <img class="avatar me-1" src="{{ member.picture }}" />
      {{ member.name }}
    </div>
  </div>

  <div
    [ngClass]="{
      'align-middle mb-1': isVertical,
      'align-middle pb-0 col-md-9 col-12': !isVertical
    }"
    >
    <div class="d-flex align-items-start flex-column">
      <span>{{ member.email }}</span>

      @if (member.isActivationPending && member.isInvitationSent) {
        <small
          class="text-accent pull-left"
          placement="top"
          container="body"
          ngbTooltip="{{ member.name }} was sent an invitation."
          >
          Pending invitation
        </small>
      }

      @if (member.isActivationPending && !member.isInvitationSent) {
        <small
          class="text-orange pull-left"
          placement="top"
          container="body"
          ngbTooltip="{{ member.name }} cannot view or edit maps."
          >
          Not yet invited
        </small>
      }

      @if (!member.isActivationPending) {
        <small
          class="text-green pull-left"
          placement="top"
          container="body"
          ngbTooltip="{{ member.name }} can view and edit maps"
          >
          Active
        </small>
      }
    </div>
  </div>
</div>
